function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import lightTokens from '@mineral/tokens/build/light/index.json';
import darkTokens from '@mineral/tokens/build/dark/index.json';

var getModeValueFn = function getModeValueFn(mode) {
  return function (light, dark) {
    return mode === 'dark' ? dark : light;
  };
};

export var createPalette = function createPalette(mode) {
  if (mode === void 0) {
    mode = 'light';
  }

  var getModeValue = getModeValueFn(mode);
  var tokens = getModeValue(lightTokens, darkTokens);
  return _extends({
    // Used by `getContrastText()` to maximize the contrast between the background and the text.
    contrastThreshold: 4.5,
    // MUI default is 3
    // Gets value from the palette based on the the mode
    getModeValue: getModeValue,
    // Shift a color's luminance within its tonal palette
    // MUI default is 0.2, approximately 2 steps in color ramp
    // Mineral ramps have greater range and therefore use a smaller offset, approximating 1 step
    tonalOffset: 0.1,
    mode: mode
  }, tokens.color, {
    grey: tokens.palette.grey
  });
};